// View: Order Complete
function view_order_complete() {
  var $ = jQuery;

  charleys_show_loading();

  if (urlParam("orderid")) {
    localStorage.setItem(
      "charleys_customer_order",
      JSON.stringify({ id: urlParam("orderid") })
    );
  }

  if (localStorage.getItem("charleys_customer_order")) {
    var session_order_data = JSON.parse(
      localStorage.getItem("charleys_customer_order")
    );
    var orderguid = session_order_data.id;

    // Remove reveal modal
    $("#order-complete-confirm-checkin, #order-complete-confirm-cancel, #order-complete-favorite-order, #order-complete-delete-favorite-order").each(function () {
      if (typeof $(this).attr("aria-hidden") !== "undefined") {
        $(this).parent().remove();
      }
    });

    $contentContainer
      .load(templateRoot + "wf-ordering-order-complete.html", function () {

        // Recreate reveal modals
        var $checkin_reveal = new Foundation.Reveal(
          $("#order-complete-confirm-checkin"),
          {}
        );
        var $cancel_reveal = new Foundation.Reveal(
          $("#order-complete-confirm-cancel"),
          {}
        );
        var $favorite_reveal = new Foundation.Reveal(
          $("#order-complete-favorite-order"),
          {}
        );
        var $delete_favorite_reveal = new Foundation.Reveal(
          $("#order-complete-delete-favorite-order"),
          {}
        );

        $('button[data-refresh-order-status]').click(function () {
          displayFinalOrder(orderguid, session_order_data);
        });

        displayFinalOrder(orderguid, session_order_data);
      })
      .hide()
      .fadeIn(transitionDuration);
  } else {
    change_view("start-order");
  }
}

function displayFinalOrder(orderguid, session_order_data) {

  var $ = jQuery;
  charleys_show_loading();
  $.ajax({
    type: "POST",
    url: ajax_url,
    data: {
      action: "olo_get_order",
      orderguid: orderguid,
    },
    success: function (response) {
      order_data = JSON.parse(response);
      showOrderStatus(order_data);

      // console.log("session_order_data");
      // console.log(session_order_data);
      // console.log("order_data");
      // console.log(order_data); 
      //display rewards upsell
      if (isUserLoggedIn(true)) {
        $('[data-reward-messaging]').removeClass('hide');
        $('[data-rewards-upsell]').addClass('hide');
      } else {
        $('[data-reward-messaging]').addClass('hide');
        $('[data-rewards-upsell]').removeClass('hide');
      }
      //end of rewards upsell
      if (order_data.deliveryaddress) {
        $('[data-delivery-address]').text(
          order_data.deliveryaddress.streetaddress + ' ' +
          order_data.deliveryaddress.building
        );
        $('[data-delivery-city]').text(
          order_data.deliveryaddress.city + ' ' +
          order_data.deliveryaddress.zipcode
        );
        if (order_data.deliveryaddress.specialinstructions) {
          $('[data-delivery-instructions]').text(order_data.deliveryaddress.specialinstructions);
          $('[data-delivery-instructions]').removeClass('hide');
        }
        $('[data-order-details-delivery]').removeClass('hide');
      }

      $("[data-order-customer-name]").text(localStorage.getItem("charleys_customer_guest_first_name") +
        " " +
        localStorage.getItem("charleys_customer_guest_last_name"));
      $("[data-order-number]").text(order_data.oloid);

      $timeText = "";
      if (order_data.delivermode == "dispatch") {
        $timeText = "Order to arrive: ";
        if (order_data.status == "Completed") {
          $timeText = "Order delivered at: ";
        }
      } else {
        $timeText = "Order to be ready: ";
        if (order_data.status == "Completed") {
          $timeText = "Order ready at: ";
        }
      }
      $("[data-order-time-text]").text($timeText);
      //display order tracker information
      //progress % and steps are different in case there are >=< 4 steps
      var progress = 0;
      var step = 0;

      var statusSwitch = order_data.status;

      if (order_data.deliverystatus) {
        statusSwitch = order_data.deliverystatus.deliveries[0].status;
      }

      $("[data-order-status]").text(statusSwitch);

      //order data status switch
      switch (statusSwitch) {
        case "New":
        case "Accepted":
        case "Transmitting":
        case "Scheduled": // Order Status Enum, Delivery Status Enum
        case "Pending Manual Fire": // Order Status Enum
        case "Pending": // Delivery Status Enum
          progress = 33.3;
          step = 1;
          break;
        case "Preparing":
        case "PickupInProgress": // Delivery Status Enum
          progress = 66.6;
          step = 2;
          break;
        case "Ready":
        case "In Progress": // Order Status Enum
        case "DeliveryInProgress": // Delivery Status Enum
          progress = 66.6;
          step = 2;
          break;
        case "Delivered": // Delivery Status Enum
        case "Completed": // Order Status Enum, Delivery Status Enum
        case "Canceled": // Order Status Enum, Delivery Status Enum
        case "Rejected":
          progress = 100;
          step = 3;
          break;
        default:
          progress = 0;
          step = 0;
      }

      // Hide ready time if irrelivant
      if (["Delivered", "Completed", "Canceled", "Rejected"].includes(statusSwitch)) {
        $('.order-status-time').addClass('hide');
      } else {
        $('.order-status-time').removeClass('hide');
      }

      $("[data-order-status-progress]").css(
        "stroke-dashoffset",
        "calc(201.06 - (201.06 * " + progress + " / 100))"
      );
      if (progress > 66.6) {
        $("[data-order-status-progress]").css("stroke", "#00b300");
      } else if (progress > 33.3) {
        $("[data-order-status-progress]").css("stroke", "#ffcc00");
      } else if (progress >= 33.3) {
        $("[data-order-status-progress]").css("stroke", "#ffcc00");
      } else {
        $("[data-order-status-progress]").css("stroke", "#E31837");
      }
      $("[data-order-step]").text(step);

      $.ajax({
        type: "POST",
        url: ajax_url,
        data: {
          action: "olo_get_restaurant",
          restaurant_id: order_data.vendorid,
          get_calendar: true,
        },
        success: function (response) {
          var restaurant_data = JSON.parse(response);

          console.log('restaurant_data', restaurant_data);
          // 
          var locationHours = '';
          $.each(restaurant_data.calendar, function (key, calendar) {
            // console.log('calendar', calendar);
            if (typeof calendar.ranges !== 'undefined' && calendar.ranges !== null && calendar.ranges.length) {
              var storeCalendar = calendar.ranges[0];
              var startDate = new Date(storeCalendar.start.substr(0, 4) + '-' + storeCalendar.start.substr(4, 2) + '-' + storeCalendar.start.substr(6, 2) + 'T' + storeCalendar.start.substr(9, 5));
              var endDate = new Date(storeCalendar.end.substr(0, 4) + '-' + storeCalendar.end.substr(4, 2) + '-' + storeCalendar.end.substr(6, 2) + 'T' + storeCalendar.end.substr(9, 5));

              var hourslabel = calendar.type.charAt(0).toUpperCase() + calendar.type.substr(1).toLowerCase();
              if (calendar.label !== null) {
                hourslabel = calendar.label.charAt(0).toUpperCase() + calendar.label.substr(1).toLowerCase();
              } else if (calendar.type == 'dinein') {
                hourslabel = "Dine In";
              }

              locationHours += '<strong>' + hourslabel + ' Hours: </strong><br>' + formatAMPM(startDate) + ' - ' + formatAMPM(endDate) + '<br>';
              // console.log('locationHours', locationHours);
              $("[data-store-hours]").html(locationHours);
            }
          });
          //Google address link
          resturantNameWithReplacedSpaced = restaurant_data.name.replace(' ', '+');
          let googleAddressLink = 'https://www.google.com/maps/dir/?api=1&destination=Charleys%2C+1+' + resturantNameWithReplacedSpaced + '+' + restaurant_data.zip;
          console.log(googleAddressLink);
          $("[data-store-direction-link]").attr("href", googleAddressLink);
          //
          var handoff_mode_label;
          var manual_fire_label;
          var thanks_instructions;
          restaurant_data.labels.forEach(function (label) {



            if (label.key == "manual_fire_label") {
              manual_fire_label = label.value;
            }

            if (label.key == "handoffmode_" + order_data.deliverymode) {
              handoff_mode_label = label.value;
            }

            if (
              label.key ==
              "thanks_" + order_data.deliverymode + "_instructions"
            ) {
              thanks_instructions = label.value;
            } else if (
              label.key ==
              "thanks_" + order_data.deliverymode + "pickup_instructions"
            ) {
              thanks_instructions = label.value;
            } else if (
              label.key ==
              "thanks_" + order_data.deliverymode + "instructions"
            ) {
              thanks_instructions = label.value;
            }
          });

          $("[data-order-checkin-label]").text(manual_fire_label);
          $("[data-order-type]").text(handoff_mode_label);
          $("[data-thanks-instructions]").text(thanks_instructions);

          console.log(order_data.deliverymode, order_data.status);

          if (
            order_data.deliverymode == "curbside" ||
            order_data.deliverymode == "pickup" ||
            order_data.deliverymode == "drivethru"
          ) {
            $("[data-order-pickup]").removeClass("hide");
            $("[data-order-checkin]").removeClass("hide");
          }

          if (order_data.status == "Completed") {
            $("[data-order-pickup]").addClass("hide");
            $("[data-order-checkin]").addClass("hide");
          }

          var supportsArrivalMessage = false;

          // todo: map this feature for order types other than curbside
          restaurant_data.supportedarrivalmessagehandoffmodes.forEach(
            function (mode) {
              if (
                mode == "CurbsidePickup" &&
                order_data.deliverymode == "curbside"
              ) {
                supportsArrivalMessage = true;
              }
            }
          );

          if (order_data.arrivalstatus != "Order Placed" || !supportsArrivalMessage) {
            $("[data-order-checkin]").addClass("hide");
          }

          $("[data-store-name]").text(restaurant_data.name);
          $("[data-order-details-header]").text(
            order_data.deliverymode + " Details"
          );
          $("[data-store-address]").text(restaurant_data.streetaddress);
          $("[data-store-city]").text(
            restaurant_data.city +
            ", " +
            restaurant_data.state +
            " " +
            restaurant_data.zip
          );
          $("[data-store-phone]").text(restaurant_data.telephone);
          $("[data-store-phone-link]").attr(
            "href",
            "tel:" + restaurant_data.telephone.replace(/\D/g, "")
          );
          $("[data-store-location-link]").attr(
            "href",
            "/locations/" + restaurant_data.slug
          );

          $("[data-store-map]").attr(
            "data-latitude",
            restaurant_data.latitude
          );
          $("[data-store-map]").attr(
            "data-longitude",
            restaurant_data.longitude
          );

          // var formatted_timeplaced =
          //   order_data.timeplaced.substring(0, 4) +
          //   "-" +
          //   order_data.timeplaced.substring(4, 6) +
          //   "-" +
          //   order_data.timeplaced.substring(6, 8) +
          //   order_data.timeplaced.substring(8);
          // $("[data-order-timeplaced]").text(formatted_timeplaced);

          // var formatted_readytime =
          //   order_data.readytime.substring(0, 4) +
          //   "-" +
          //   order_data.readytime.substring(4, 6) +
          //   "-" +
          //   order_data.readytime.substring(6, 8) +
          //   order_data.readytime.substring(8);
          // // $("[data-order-readytime]").text(formatted_readytime);
          // var time_formatted_readytime = order_data.readytime.substr(
          //   order_data.readytime.length - 5
          // );
          // //convert to 12 hour time if string is xx:xx
          // if (time_formatted_readytime.length == 5) {
          //   var hours = time_formatted_readytime.substr(0, 2);
          //   var minutes = time_formatted_readytime.substr(3, 2);
          //   var ampm = hours >= 12 ? "PM" : "AM";
          //   hours = hours % 12;
          //   hours = hours ? hours : 12; // the hour '0' should be '12'
          //   time_formatted_readytime = hours + ":" + minutes + " " + ampm;
          // }

          // $("[data-order-readytime-time]").text(time_formatted_readytime);

          //display map of order location
          if (window.location.href.indexOf("/order/") > -1) {
            function initMap(longitude, latitude) {
              var $ = jQuery;
              tt.setProductInfo("Charleys Location Map", "2.0.0");
              if ($("#tt-map").length) {
                ttmap = tt.map({
                  key: tomtom_api_key,
                  container: "tt-map",
                  center: [longitude, latitude],
                  zoom: 15,
                  language: "en-US",
                });
                if (window.innerWidth > 1380) {
                  // Set the width and height of the container directly
                  var mapContainer = document.getElementById('tt-map');
                  mapContainer.style.width = '800px';
                  mapContainer.style.height = '300px';

                  // Apply same dimensions to the canvas
                  var canvas = mapContainer.querySelector('.mapboxgl-canvas');
                  canvas.style.width = '800px';
                  canvas.style.height = '300px';
                  canvas.setAttribute('width', '800px');
                  canvas.setAttribute('height', '300px');

                  console.log("order page, map loading");

                  // Add a slight delay before calling resize
                  setTimeout(function () {
                    ttmap.resize();
                  }, 100); // Adjust delay if needed
                }

              }

            } // end initMap
            initMap(restaurant_data.longitude, restaurant_data.latitude);
            //add marker to map
            var markerElement = document.createElement("div");
            markerElement.className = "marker";

            var markerContentElement = document.createElement("div");
            markerContentElement.className = "marker-content";
            markerElement.appendChild(markerContentElement);

            // add marker to map
            var marker = new tt.Marker({
              element: markerElement,
              anchor: "bottom",
            })
              .setLngLat([
                restaurant_data.longitude,
                restaurant_data.latitude,
              ])
              .addTo(ttmap);
            console.log(marker);
          }

          $("[data-order-subtotal]").text(
            "$" + formatMoney(order_data.subtotal)
          );
          $("[data-order-tax]").text(
            "$" + formatMoney(order_data.salestax)
          );

          if (order_data.customerhandoffcharge > 0) {
            $("[data-order-delivery-fee]").text(
              "$" + formatMoney(order_data.customerhandoffcharge)
            );
            $(".delivery-fee-product-item").removeClass("hide");
          }

          if (order_data.tip > 0) {
            $("[data-order-tip]").text("$" + formatMoney(order_data.tip));
            $(".tip-product-item").removeClass("hide");
          }

          if (order_data.discount > 0) {
            $("[data-order-coupon]").text(
              "($" + formatMoney(order_data.discount) + ")"
            );
            $(".coupon-product-item").removeClass("hide");
          }

          $("[data-order-total]").text(
            "$" + formatMoney(order_data.total)
          );

          // Clear product selection readout in event of reload
          $("[data-order-complete-product-selections]  .product-item:not(.hide)").each(function () {
            $(this).remove();
          })
          let restaurant_id = localStorage.getItem("charleys_customer_store_location_id");

          order_data.products.forEach(function (product) {
            // console.log('product', product);
            // console.log('order_data', order_data);
            var $product_item = $("[data-order-complete-product-selections] .product-item.hide").clone();

            //product img stuff 
            $product_item
              .find("[data-product-img]")
              .attr("id", product.productId);

            let productsIdForGettingImg = product.id;
            let productsOrderImgs = JSON.parse(localStorage.getItem('productsOrderImgs')) || [];
            let existingProduct = productsOrderImgs.find(item => item.id === productsIdForGettingImg);

            if (existingProduct) {
              console.log('The variable productsIdForGettingImg exists in local storage.');
              $product_item.find("[data-product-img]").attr("src", existingProduct.imagePath).removeClass("hide");
            } else if (restaurant_id) {
              console.log('Call ajax for productsIdForGettingImg');

              $.ajax({
                type: "POST",
                url: ajax_url,
                data: {
                  action: "get_olo_get_menu",
                  restaurant_id: restaurant_id,
                },
                success: function (response) {
                  let rawProductData = JSON.parse(response);
                  // console.log('Raw Response:', rawProductData); 
                  function getMenuItemImages(categoryType) {
                    // console.log('categories', categoryType);
                    if (categoryType && categoryType.length > 0) {
                      categoryType.forEach(category => {
                        if (category.products && category.products.length > 0) {
                          // Iterate over products within each category
                          category.products.forEach(product => {
                            // Check if the product ID is in the productsIdForGettingImg array
                            if (productsIdForGettingImg === product.id) {
                              let formattedImagePath;
                              let productsOrderImgs = JSON.parse(localStorage.getItem('productsOrderImgs')) || [];


                              if (product.imagefilename) {
                                // Log the image filename
                                // console.log('Image Filename:', rawProductData.imagepath + product.imagefilename);
                                formattedImagePath = rawProductData.imagepath + product.imagefilename;


                                $("#" + product.id + "[data-product-img]")
                                  .attr("src", formattedImagePath).removeClass("hide");


                                console.log('cart', "#" + product.id + "[data-product-img]");
                              } else {
                                formattedImagePath = '/wp-content/themes/Charleys/assets/images/charleys-product-placeholder.svg';
                                $("#" + product.id + "[data-product-img]")
                                  .attr("src", formattedImagePath).removeClass("hide");
                              }
                              productsOrderImgs.push({
                                id: product.id,
                                imagePath: formattedImagePath
                              });
                              // Store the productsOrderImgs array in local storage
                              localStorage.setItem('productsOrderImgs', JSON.stringify(productsOrderImgs));
                              console.log('Stored productsOrderImgs in local storage:', productsOrderImgs);
                            }
                          });
                        } else {
                          console.log('No products found in this category');
                        }

                      });
                    }
                  }
                  getMenuItemImages(rawProductData.categories);
                  getMenuItemImages(rawProductData.singleusecategories);  
                }
              });
            } else {
              // console.log('no work ;(');
            }

            //end of product img stuff 
            $product_item
              .find("[data-product-item-name]")
              .text(product.name);
            $product_item
              .find("[data-product-item-custom]")
              .text(product.specialinstructions);
            //for each item in choices array in product add the span with the item to the item-options div
            if (product.choices && product.choices.length) {
              var choices = [];
              // console.log('product.choices', product.choices);

              for (var ii = 0; ii < product.choices.length; ii++) {
                var choice = product.choices[ii].name;
                // console.log('choice', choice);

                // Filter out YES and NO option selections to add clarity to option choices
                if (choice.toLowerCase().trim() !== "no" &&
                  choice.toLowerCase().trim() !== "yes" &&
                  choice.toLowerCase().trim() !== "product size") {

                  if (product.choices[ii].quantity > 1) {
                    var qty = Number(product.choices[ii].quantity);
                    choice = "(" + qty + ") " + choice;
                  }

                  // Add the choice to the choices array
                  choices.push(choice);
                }
              }

              // Join all the choices into a single string separated by commas
              var choicesText = choices.join(', ');

              if (choicesText.length && !choicesText.includes('Product size')) {
                $product_item.find("[data-product-item-options]").text(choicesText);
              }
            } else {
              $product_item.find("[data-product-item-options]").addClass("hide");
            }


            $product_item
              .find("[data-product-item-price]")
              .text("$" + formatMoney(product.totalcost));

            $product_item.removeClass("hide");
            $("[data-order-complete-product-selections]").append(
              $product_item
            );
          });

          var show_edit_section = false;
          if (order_data.iseditable) {
            //$('[data-order-complete-edit-order]').removeClass('hide');
            //show_edit_section = true;
          }

          if (
            order_data.status == "Scheduled" ||
            order_data.status == "Pending Manual Fire"
          ) {
            $("[data-order-complete-cancel-order]").removeClass("hide");
            show_edit_section = true;
          }

          if (show_edit_section) {
            $("[data-order-complete-edit-order-section]").removeClass(
              "hide"
            );
          }

          $("[data-order-complete-cancel-order]").off("click");
          $("[data-order-complete-cancel-order]").click(function () {
            $("#order-complete-confirm-cancel").foundation("open");
          });

          $(".confirm-cancel-button").off("click");
          $(".confirm-cancel-button").click(function () {
            $.ajax({
              type: "POST",
              url: ajax_url,
              data: {
                action: "olo_cancel_order",
                orderguid: order_data.id,
              },
              success: function (response) {
                var cancel_result = JSON.parse(response);
                console.log(cancel_result);
                if (cancel_result.status == "Canceled") {
                  window.location.reload();
                } else {
                  $(".confirm-cancel-error").removeClass("hide");
                  $("#order-complete-confirm-cancel").foundation("open");
                }
              },
            });
          });

          $(".checkin-button").off("click");
          $(".checkin-button").click(function () {
            $("#order-complete-confirm-checkin").foundation("open");
          });

          $(".confirm-checkin-button").off("click");
          $(".confirm-checkin-button").click(function () {
            $.ajax({
              type: "POST",
              url: ajax_url,
              data: {
                action: "olo_submit_customer_arrival",
                orderguid: order_data.id,
              },
              success: function (response) {
                console.log(response);
                $("[data-order-checkin]").addClass("hide");
              },
            });
          });

          $(".order-complete-favorite-button").off("click");
          $(".order-complete-favorite-button").click(function () {
            if ($(this).hasClass("location-favorite-active")) {
              $("#order-complete-delete-favorite-order").foundation(
                "open"
              );
            } else {
              $("#order-complete-favorite-order").foundation("open");
            }
          });

          if (localStorage.getItem("charleys_auth_token")) {
            $(".confirm-favorite-button").off("click");
            $(".confirm-favorite-button").click(function () {
              $.ajax({
                type: "POST",
                url: ajax_url,
                data: {
                  action: "olo_create_basket_from_order",
                  authtoken: localStorage.getItem("charleys_auth_token"),
                  orderid: order_data.id,
                },
                success: function (response) {
                  basket_result = JSON.parse(response);

                  if (basket_result.id) {
                    $.ajax({
                      type: "POST",
                      url: ajax_url,
                      data: {
                        action: "olo_set_fave",
                        authtoken: localStorage.getItem(
                          "charleys_auth_token"
                        ),
                        basketid: basket_result.id,
                        description: $(
                          "[data-favorite-order-description]"
                        ).val(),
                      },
                      success: function (response) {
                        fave_result = JSON.parse(response);

                        if (fave_result.code == 200) {
                          alert(fave_result.message);
                          $("#order-complete-favorite-order").foundation(
                            "open"
                          );
                        } else if (fave_result.faves[0].id) {
                          $("[data-fave-id]").text(
                            fave_result.faves[0].id
                          );

                          $(".order-complete-favorite-button").addClass(
                            "location-favorite-active"
                          );
                        }
                      },
                    });
                  }
                },
              });
            });
          } else {
            $(".order-complete-favorite-button").addClass("hide");
            $(".confirm-favorite-button").addClass("hide");
          }

          if (localStorage.getItem("charleys_auth_token")) {
            $(".delete-favorite-button").off("click");
            $(".delete-favorite-button").click(function () {
              $.ajax({
                type: "POST",
                url: ajax_url,
                data: {
                  action: "olo_delete_fave",
                  authtoken: localStorage.getItem("charleys_auth_token"),
                  faveid: $("[data-fave-id]").text(),
                },
                success: function (response) {
                  $("[data-fave-id]").text("");
                  $(".order-complete-favorite-button").removeClass(
                    "location-favorite-active"
                  );
                },
              });
            });
          } else {
            $(".order-complete-favorite-button").addClass("hide");
            $(".delete-favorite-button").addClass("hide");
          }



          $("[data-order-complete]").removeClass("hide");
          charleys_hide_loading();
        },
      });
    },
  });


}

